<!--
 * @Author: your name
 * @Date: 2021-06-21 16:09:10
 * @LastEditTime: 2021-07-07 16:49:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\views\Im\Im.vue
-->
<template>
    <div class="box">
        <div class="friend">
            <div class="friend-list">
                <Tab></Tab>
            </div>
            <div class="msg">
                <div style="position:absolute;right:10px;top:10px" @click="close">
                    <a-icon type="close" />
                </div>
                <Meg></Meg>
            </div>
        </div>
            <!-- <ChoList></ChoList> -->
    </div>
</template>

<script>
    import Tab from './components/tab.vue'
    import Meg from './components/message.vue'
    import ChoList from './chooseList.vue'
    export default {
        components: {
            Tab,Meg,ChoList
        },
        data() {
            return {
                
            }
        },
        created() {

        },
        methods: {
            close(){
                this.$emit('close','')
            }
        }
    }

</script>
<style scoped>
    .box {
        /* width: 50%;
        height: 70%; */
    }

    .friend {
         width: 100%;
        display: flex;
        flex-direction: row;
    }

    .friend-list {
        width: 40%;
        height: 654px;
        background-color: #eeeae8;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        /* display: flex;
        flex-direction: row; */
    }

    /* .friend-tab{
        width: 8%;
        height: 654px;
        border: 1px solid #f90;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        background-color: #eeeae8;
    } */
    .msg {
        position: relative;
        width: 60%;
        height: 654px;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        background-color: #f5f5f5
    }

    .msg-t {
        width: 100%;
        height: 70%;
        border: 1px solid #f90;

    }

    .msg-c {
        width: 100%;
        height: 5%;
        border: 1px solid #f90;
    }

    .msg-b {
        width: 100%;
        height: 25%;
        border: 1px solid #f90;
    }
    
</style>


// WEBPACK FOOTER //
// src/SRM/views/Im/Im.vue